import { lazy } from "react";
const Dashboard = lazy(() => import("../pages/dashboard/dashboard"));
const Login = lazy(() => import("../pages/auth/login"));
const Users = lazy(() => import("../pages/users/list"));
// const AddUser = lazy(() => import("../pages/users/addUser"));
const Brands = lazy(() => import("../pages/brands/list"));
const AddBrand = lazy(() => import("../pages/brands/add"));
const AddUser = lazy(() => import("../pages/users/add"));
const PasswordReset = lazy(() => import("../pages/auth/password-reset/index"));
const CreatePassword = lazy(() => import("../pages/auth/create-password/index"));
const ForgotPassword = lazy(() => import("../pages/auth/forgot-password/index"));

const routes = {
  LOGIN: {
    path: "/login",
    component: Login,
    requireLogin: false,
    allowAccessWhenLoggedIn: false,
    pageTitle: "Login",
  },
   RESET_PASSWORD: {
    path: "/reset-password",
    component: PasswordReset,
    requireLogin: false,
    allowAccessWhenLoggedIn: false,
    pageTitle: "Reset Password",
  },
  CREATE_PASSWORD: {
    path: "/create-password",
    component: CreatePassword,
     requireLogin: false,
    allowAccessWhenLoggedIn: false,
    pageTitle: "Create Password",
  },
  FORGOT_PASSWORD: {
    path: "/forgot-password",
    component: ForgotPassword,
     requireLogin: false,
    allowAccessWhenLoggedIn: false,
    pageTitle: "Forgot Password",
  },
  DASHBOARD: {
    path: "/",
    component: Dashboard,
    withSidebar: true,
    pageTitle: "Sales Tracking - Dashboard",
  },
  USERS: {
    path: "/users",
    component: Users,
    // requireLogin: false,
    withSidebar: true,
    pageTitle: "Users",
  },
  ADD_USER: {
    path: "/add-user",
    component: AddUser,
    // requireLogin: false,
    withSidebar: true,
    pageTitle: "Add User",
  },
  EDIT_USER: {
    path: "/edit-user/:id",
    component: AddUser,
    // requireLogin: false,
    withSidebar: true,
    pageTitle: "Add User",
  },
  BRAND: {
    path: "/brands",
    component: Brands,
    withSidebar: true,
    pageTitle: "Brands",
  },
  ADD_BRAND: {
    path: "/add-brand",
    component: AddBrand,
    withSidebar: true,
    pageTitle: "Add Brand",
  },
  EDIT_BRAND: {
    path: "/edit-brand/:id",
    component: AddBrand,
    withSidebar: true,
    pageTitle: "Edit Brand",
  },
};

export default routes;
